var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBackforthLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61279 7.4375H8.17578M4.61279 5.02344H6.39429",
    stroke: "#96989F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6437 5.8106C12.489 3.42927 10.601 1.53194 8.23032 1.37594C7.42165 1.3226 6.57698 1.3226 5.77032 1.37594C3.39965 1.53194 1.51165 3.42927 1.35698 5.8106C1.32632 6.27727 1.32632 6.75927 1.35698 7.22527C1.41298 8.09327 1.80032 8.89594 2.25632 9.5746C2.52098 10.0493 2.34632 10.6413 2.07032 11.1593C1.87165 11.5326 1.77232 11.7193 1.85232 11.8539C1.93232 11.9886 2.11032 11.9933 2.46698 12.0013C3.17165 12.0186 3.64698 11.8206 4.02432 11.5446C4.23832 11.3886 4.34565 11.3106 4.41965 11.3013C4.49298 11.2926 4.63832 11.3513 4.92832 11.4699C5.18965 11.5766 5.49232 11.6419 5.77032 11.6606",
    stroke: "#96989F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3551 14.47C8.87283 14.3791 7.69237 13.2734 7.59566 11.8852C7.57649 11.6137 7.57649 11.3324 7.59566 11.0608C7.69237 9.67305 8.87283 8.56735 10.3551 8.47644C10.8607 8.44535 11.3888 8.44535 11.8932 8.47644C13.3754 8.56735 14.5559 9.67305 14.6526 11.0608C14.6718 11.3328 14.6718 11.6137 14.6526 11.8852C14.6176 12.3911 14.3754 12.8588 14.0903 13.2543C13.9248 13.531 14.034 13.8759 14.2066 14.1778C14.3308 14.3954 14.3929 14.5042 14.3429 14.5826C14.2929 14.6611 14.1816 14.6638 13.9586 14.6685C13.518 14.6786 13.2208 14.5632 12.9849 14.4024C12.8511 14.3115 12.784 14.266 12.7377 14.2606C12.6918 14.2555 12.601 14.2897 12.4196 14.3589C12.2562 14.421 12.067 14.4591 11.8932 14.47C11.3888 14.5011 10.8607 14.5011 10.3551 14.47Z",
    stroke: "#96989F",
    strokeWidth: 0.924214,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75659 12.2109H12.4917M9.75659 10.4609H11.1241",
    stroke: "#96989F",
    strokeWidth: 0.833557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBackforthLight);
export default __webpack_public_path__ + "static/media/chat-backforth-light.f0f00d5e4e33967355eb008b1ba03d69.svg";
export { ForwardRef as ReactComponent };